// extracted by mini-css-extract-plugin
export default {"Subpage":"basicStatistics_Subpage__ORv4r","TopFivePatternsContainer":"basicStatistics_TopFivePatternsContainer__ZDG0f"};